<template>
    <div class="customizationX sjzq-zxfu-page">
        <div class="notaryServices_content_titles">服务咨询</div>
        <div class="notaryServices_gzzx">
            <div class="notaryServices_gzzxtext">
                <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-position="top"
                    class="demo-ruleForm h5-form" :size="formSize" status-icon>

                    <div class="formItem">
                        <div class="formLabel">咨询地区<span class="required">*</span></div>
                        <el-form-item prop="zxdq1" class="no-label">
                            <div class = 'zxdqBox'>
                                <el-cascader ref='addressCode' size="large" class="form-select" v-model="ruleForm.zxdq1"
                                style="height: 40px;width: 100%;font-size: 16px;color:#191919"
                                popper-class="my-cascader-popper" :fit-input-width="true"
                                :options="treeList" @change="handleChange" :props='CascaderProps'
                                placeholder="请选择咨询地区" placement="bottom-start" />
                            </div>
                            
                        </el-form-item>
                    </div>

                    <div class="formItem">
                        <div class="formLabel">咨询类型<span class="required">*</span></div>
                        <el-form-item prop="zxlx" class="no-label">
                            <el-select style="height: 40px;width: 100%;font-size: 16px;color:#191919" :teleported="false" v-model="ruleForm.zxlx" filterable class="form-select"
                                placeholder="请选择咨询类型" size="large">
                                <el-option v-for="item in tabsItem" :key="item._id" :label="item.zxlx"
                                    :value="item._id" />
                            </el-select>
                        </el-form-item>
                    </div>

                    <div class="formItem">
                        <div class="formLabel">公司名称</div>
                        <el-form-item prop="gsmc" class="no-label">
                            <el-input style="height: 40px;width: 100%;font-size: 16px;" v-model="ruleForm.gsmc" placeholder="请输入公司名称" class="form-input" />
                        </el-form-item>
                    </div>

                    <div class="formItem">
                        <div class="formLabel">公司职务</div>
                        <el-form-item prop="gszw" class="no-label">
                            <el-input v-model="ruleForm.gszw" placeholder="请输入公司职务" class="form-input" />
                        </el-form-item>
                    </div>

                    <div class="formItem">
                        <div class="formLabel">姓名<span class="required">*</span></div>
                        <el-form-item prop="xm" class="no-label">
                            <el-input style="height: 40px;width: 100%;font-size: 16px;" v-model="ruleForm.xm" placeholder="请输入姓名" class="form-input" />
                        </el-form-item>
                    </div>

                    <div class="formItem">
                        <div class="formLabel">手机号码<span class="required">*</span></div>
                        <el-form-item prop="sjhm" class="no-label">
                            <el-input style="height: 40px;width: 100%;font-size: 16px;" v-model="ruleForm.sjhm" placeholder="请输入联系手机号" class="form-input" />
                        </el-form-item>
                    </div>

                    <div class="formItem">
                        <div class="formLabel">咨询内容<span class="required">*</span></div>
                        <el-form-item prop="zxnr" class="no-label">
                            <el-input style="font-size: 16px;" v-model="ruleForm.zxnr" :autosize="{ minRows: 5, maxRows: 5 }" type="textarea"
                                placeholder="请输入想要咨询的外贸服务内容" class="form-textarea" />
                        </el-form-item>
                    </div>

                    <el-form-item class="submit-item">
                        <div class="btn" @click="submitForm(ruleFormRef)">
                            立即提交咨询
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
import { getCurrentInstance, ref, watch, computed, onMounted, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
    name: "secondPage",

    setup(props) {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        let articleData = ref({});
        const ruleFormRef = ref(null)
        const tabsItem = ref([])
        const addressCode = ref('')
        const CascaderProps = ref({ label: 'name', value: 'code', children: 'children' })
        const getTyleList = () => {   //法律类型接口
            proxy.$request({
                url: "QPSTZX_GJDLYSFW_ZXFLLIST",
                method: "post",
                data: {}
            }).then((res) => {
                if (res.data.code == "000") {
                    res.data.result.forEach((item, index) => {
                        if (index <= 3) {
                            tabsItem.value.push({
                                sort: index + 1,
                                ...item
                            })
                        } else {
                            if (index == 4) {
                                tabsItem.value.push({
                                    sort: 1,
                                    ...item
                                })
                            } else if (index == 5) {
                                tabsItem.value.push({
                                    sort: 2,
                                    ...item
                                })
                            } else if (index == 6) {
                                tabsItem.value.push({
                                    sort: 3,
                                    ...item
                                })
                            } else if (index == 7) {
                                tabsItem.value.push({
                                    sort: 4,
                                    ...item
                                })
                            }
                        }
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        getTyleList()
        const treeList = ref([])
        const getlisttree = () => {
            proxy.$request({
                url: "B2B_W_AREA_FINDAREATREE",
                method: "post",
                data: {
                },
            }).then((res) => {
                if (res.data.code == '000') {
                    treeList.value = res.data.result[0].children
                }
            }).catch((err) => {
                console.log(err)
            })
        }
        getlisttree()

        const handleChange = (value) => {
            console.log(value, 222)
            console.log(addressCode.value.getCheckedNodes().lastItem.pathLabels)
            let arr = addressCode.value.getCheckedNodes().lastItem.pathLabels
            ruleForm.value.zxdq = arr[0] + '/' + arr[1] + '/' + arr[2]
            ruleForm.value.dqdm = value[2]
        }

        const ruleForm = ref({})
        const rules = ref({
            zxdq1: [
                { required: true, message: "请选择咨询地区", trigger: "blur" },
            ],
            xm: [
                { required: true, message: "请输入姓名", trigger: "blur" },

            ],
            sjhm: [
                { required: true, message: "请输入联系手机号", trigger: "blur" },

            ],
            zxlx: [
                { required: true, message: "请选择咨询类型", trigger: "change" }
            ],
            zxnr: [
                { required: true, message: "请输入咨询内容", trigger: "blur" },

            ],
        })
        const updateTheme = () => {
            document.documentElement.style.setProperty('--el-color-error', props.themeColor);
        }
        updateTheme()

        const submitForm = async (formEl) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    addList()
                    console.log(ruleForm.value, '2222')
                } else {
                    console.log('error submit!', fields)
                }
            })
        }
        const addList = () => {   //保存数据
            proxy.$request({
                url: "FLZX_FLZXADD",
                method: "post",
                data: ruleForm.value
            }).then((res) => {
                if (res.data.code == "000") {
                    proxy.$message({
                        type: "success",
                        message: "提交成功"
                    });
                    ruleForm.value = {}
                    ruleFormRef.value.resetFields();
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        const areaData = ref([]);
        const cxls = () => { //查询律所
            proxy.$request({
                url: "LSGL_LIST",
                data: {},
            })
                .then((res) => {
                    areaData.value = res.data.result
                })
                .catch((err) => {
                    console.log(err);
                });
        }

        const notaryServicesref = ref(null);
        const footerHeight = ref(0);
        onMounted(async () => {
            await nextTick();
            if (notaryServicesref.value) {
                footerHeight.value = notaryServicesref.value.offsetHeight
            }

            window.addEventListener('resize', () => {
                if (notaryServicesref.value) {
                    footerHeight.value = notaryServicesref.value.offsetHeight
                }
            });
        });
        cxls()
        return {
            articleData,
            notaryServicesref,
            ruleForm,
            ruleFormRef,
            areaData,
            rules,
            submitForm,
            getTyleList,
            tabsItem,
            getlisttree,
            treeList,
            handleChange,
            CascaderProps,
            addressCode
        };
    },
};
</script>


<style lang="less">
// ==========================================
// 卓创数据专区 - 服务咨询表单样式
// 唯一命名空间，防止样式泄露
// ==========================================


    .customizationX {
        width: 100%;
        height: 100%;
        // background: #fff;
        box-sizing: border-box;
        padding-bottom: 0.3rem;
        padding-top: 0.3rem;
    }

    .notaryServices_content_titles {
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.32rem;
        color: #191919;
        line-height: 1.4;
        margin-bottom: 0.3rem;
    }

    .notaryServices_gzzx {
        box-sizing: border-box;

        .notaryServices_gzzxtext {
            box-sizing: border-box;
            // background: #fff;
            padding: 0;
        }
    }

    // H5表单样式 - 上下布局
    .h5-form {
        padding: 0 0rem;

        .formItem {
            margin-bottom: 0.4rem;

            .formLabel {
                font-size: 0.28rem;
                color: #191919;
                margin-bottom: 0.15rem;
                font-weight: 500;

                .required {
                    color: #FF4D4F;
                    margin-left: 0.04rem;
                }
            }

            .no-label {
                margin-bottom: 0;
            }

            .zxdqBox {
                width: 100%;
            }
        }

        .form-input {
            width: 100%;
            font-size: 16px !important;
            height: 0.8rem !important;

            .el-input__wrapper {
                padding: 0 0.24rem;
                height: 0.8rem;
                border-radius: 0.08rem;
                display: flex;
                align-items: center;
                font-size: 16px !important;
            }

            .el-input__inner {
                font-size: 0.28rem;
                color: #191919;
                height: 0.7rem;
                line-height: 0.7rem;
                font-size: 16px !important;

                &::placeholder {
                    color: #BFBFBF;
                    font-size: 16px !important;
                }
            }
        }
        .el-form-item__content{
            .el-input__inner{
                font-size:16px!important;
                color:#191919!important;
            }
        }

        .form-select {
            width: 100%;
            .el-input__inner{
                font-size:16px!important;
                color:#191919!important;
            }

            .el-select__wrapper {
                min-height: 0.8rem;
                padding: 0 0.24rem;
                border-radius: 0.08rem;
                font-size: 16px !important;
                display: flex;
                align-items: center;
                color: #191919 !important;
            }

            .el-select__selected-item {
                color: #191919!important;
                font-size: 16px !important;
            }

            .el-select__placeholder {
                font-size: 16px !important;
                color: #191919 !important;

                &.is-transparent {
                    color: #BFBFBF !important;
                }
            }
        }

        .form-textarea {
            margin-bottom: 0.3rem;

            .el-textarea__inner {
                border-radius: 0.08rem;
                font-size: 16px !important;
                padding: 0.2rem 0.24rem;
                resize: none;
                color:#191919!important;
            }

            .el-form-item__error {
                position: static;
                padding-top: 0.08rem;
                font-size: 0.22rem;
            }
        }

        .submit-item {
            margin-top: 0.5rem;
            margin-bottom: 0;
            width: 100%;
            display: flex;
            justify-content: space-around;

            .btn {
                width: 2.68rem;
                height: 0.8rem;
                display: flex;
                justify-content: space-around;
                align-items: center;
                font-size: 0.28rem;
                color: #191919;
                border-radius: 0.44rem;
                background: #fff;
                border: 1px solid #191919;
                font-weight: 900;
                margin: 0 auto;
            }
        }
    }

    // Element UI 表单项 H5 适配
    .el-form-item {
        margin-bottom: 0.3rem;
    }

    .el-form-item__error {
        font-size: 0.22rem;
        padding-top: 0.08rem;
        position: static;
        float: none;
    }

    // 级联选择器样式
    .el-cascader {
        width: 100%;

        .el-input__wrapper {
            padding: 0 0.24rem;
            height: 0.8rem;
            border-radius: 0.08rem;
            display: flex;
            align-items: center;
        }
    }

    .el-select {
        width: 100%;
    }

    // 级联选择器下拉弹框样式
    .my-cascader-popper {
        width: 100% !important;
        max-width: calc(100vw - 0.64rem) !important;
        left: 0.32rem !important;

        .el-cascader-panel {
            display: flex !important;
            flex-direction: row !important;
            width: 100% !important;
        }

        .el-cascader-menu {
            flex: 1 !important;
            width: 33.333% !important;
            min-width: 33.333% !important;
            max-width: 33.333% !important;
            box-sizing: border-box !important;

            &:last-child {
                border-right: none !important;
            }
        }

        .el-cascader-menu__wrap {
            height: auto !important;
            max-height: 5rem !important;
            overflow-y: auto !important;
        }

        .el-cascader-menu__list {
            display: flex !important;
            flex-direction: column !important;
        }

        .el-cascader-node {
            padding: 0 0.2rem !important;
            height: 0.7rem !important;
            line-height: 0.7rem !important;
            font-size: 0.28rem !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            display: flex !important;
            align-items: center !important;
            box-sizing: border-box !important;

            .el-checkbox {
                display: flex !important;
                align-items: center !important;
                overflow: hidden;

                .el-checkbox__label {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    line-height: 0.7rem !important;
                }
            }
        }
    }

</style>

